import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { updateProfile, changePassword, closeAccount, logOut } from 'actions/index';
import Modal from 'components/Modal';
import H4 from 'components/H4';
import ButtonText from 'components/ButtonText';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Colors } from 'modules/theme';
import { listHeaderPrimaryButtonStyles } from 'constants/listHeaderButtons';
import { KineticoRolesCode } from 'constants/index';
import SettingsSectionTitle from './SettingsSectionTitle';
import LogoutView from './LogoutView';
import EditProfileView from './EditProfileView';
import ChangePasswordView from './ChangePasswordView';
import AlertSetupView from './AlertSetupView';
import CloseAccountView from './CloseAccountView';

const infoEmailChanged = {
  title: 'The app will log out because you changed your email address.',
  message: 'Please, log in again.',
};

const infoAccountClosed = {
  title: 'The app will log out because you closed your account.',
  message: '',
};

const infoPasswordChanged = {
  title: 'The app will log out because you changed your password.',
  message: 'Please, log in again.',
};

const Container = styled.div`
  padding: 24px;
  @media (max-width: 767px) {
    padding: 16px 16px 80px 16px;
  }
`;

const Section = styled.section`
  background-color: ${Colors.white};
  border: 1px solid #ecebf0;
  border-radius: 12px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  padding: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
  @media (max-width: 767px) {
    padding: 16px;
    margin-bottom: 16px;
  }
`;

const ChangelogDescription = styled.p`
  margin: 0 0 16px 0;
  font-size: 14px;
  color: ${Colors.gray8};
  max-width: 600px;
  line-height: 1.5;
  @media (max-width: 767px) {
    max-width: 100%;
  }
`;

const ChangelogButtonWrap = styled.div`
  margin-top: 8px;
`;

class SettingsContainer extends Component {
  state = { modalInfo: { title: '', message: '' } };

  renderAlert = () => {
    const { requireLogout } = this.props;
    const {
      modalInfo: { title, message },
    } = this.state;
    return (
      <Modal title="Alert" isVisible={requireLogout} onClose={() => {}} size="small">
        <H4 textAlign="center">{title}</H4>
        <H4 textAlign="center">{message}</H4>
      </Modal>
    );
  };

  onDeleteAccount = () => {
    const { deleteAccount } = this.props;
    this.setState({ modalInfo: infoAccountClosed }, () => {
      deleteAccount();
    });
  };

  onEditProfile = profile => {
    const { editProfile } = this.props;
    this.setState({ modalInfo: infoEmailChanged }, () => {
      editProfile(profile);
    });
  };

  onEditPassword = (currentPassword, password) => {
    const { editPassword } = this.props;
    this.setState({ modalInfo: infoPasswordChanged }, () => {
      editPassword(currentPassword, password);
    });
  };

  render() {
    const { profile, logout, editProfile } = this.props;
    const canViewChangelog = profile && KineticoRolesCode.includes(profile.role_code);

    return (
      <Container>
        <LogoutView logout={logout} />

        <Section>
          <EditProfileView editProfile={this.onEditProfile} profile={profile} />
        </Section>

        <Section>
          <ChangePasswordView editPassword={this.onEditPassword} />
        </Section>

        <Section>
          <AlertSetupView editProfile={editProfile} profile={profile} />
        </Section>

        {canViewChangelog && (
          <Section>
            <SettingsSectionTitle>Changelog</SettingsSectionTitle>
            <ChangelogDescription>
              See a description of the latest changes we have made to Kinetico Pro Aquarian.
            </ChangelogDescription>
            <ChangelogButtonWrap>
              <Link to="/changelog" style={{ textDecoration: 'none' }}>
                <ButtonText
                  text="View Changelog"
                  theme="primary"
                  customStyles={listHeaderPrimaryButtonStyles}
                />
              </Link>
            </ChangelogButtonWrap>
          </Section>
        )}

        <Section>
          <CloseAccountView deleteAccount={this.onDeleteAccount} />
        </Section>

        {this.renderAlert()}
      </Container>
    );
  }
}

function mapStateToProps(state) {
  return {
    profile: state.auth.profile,
    requireLogout: state.auth.requireLogout,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    editProfile: profile => dispatch(updateProfile(profile)),
    editPassword: (currentPassword, password) =>
      dispatch(changePassword(currentPassword, password)),
    deleteAccount: () => dispatch(closeAccount()),
    logout: () => dispatch(logOut()),
  };
}

SettingsContainer.propTypes = {
  deleteAccount: PropTypes.func,
  editPassword: PropTypes.func,
  editProfile: PropTypes.func,
  logout: PropTypes.func,
  profile: PropTypes.object,
  requireLogout: PropTypes.bool,
};
export default connect(mapStateToProps, mapDispatchToProps)(SettingsContainer);
